<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
  @for (toast of toasts; track trackByFn($index, toast)) {
    <div [ngClass]="getToastClass(toast.type)" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        <i [ngClass]="getIconClass(toast.type)" class="me-2"></i>
        <strong class="me-auto">{{ getTitle(toast.type) }}</strong>
        <small class="text-muted">now</small>
        <button type="button" class="btn-close" (click)="removeToast(toast)" aria-label="Close"></button>
      </div>
      <div class="toast-body">
        {{ toast.message }}
      </div>
    </div>
  }
</div>
